export default "__VITE_PUBLIC_ASSET__70712d5a__"